module.exports = __webpack_public_path__ + "img/healthcheck-icon.1d4ba0d7.png";